<template>

  <!-- ======================= Main banner START -->
<section class="pt-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <!-- Card item START -->
          <div
            class="card overflow-hidden h-100px h-xl-200px rounded-3"
            style="
              background-image: url(/assets/images/bg/fondo-acercade-viaverde.jpg);
              background-position: center left;
              background-size: cover;
            "
          >
            <!-- Background dark overlay -->
            <div class="bg-overlay bg-dark opacity-6"></div>

            <!-- Card image overlay -->
            <div class="card-img-overlay d-flex align-items-start flex-column">
              <!-- Card overlay Top -->
              <!-- <div class="w-100 mb-auto d-flex justify-content-end">
							<button class="btn btn-sm btn-white mb-0"><i class="bi bi-share"></i> Share</button>
						</div> -->
              <!-- Card overlay bottom -->
              <div class="w-100 mt-auto">
                <div class="row p-0 p-sm-3">
                  <div class="col-11 col-lg-7">
                    <!-- Title -->
                    <!-- <h1 class="text-white">¿Preparado para exportar? responde al Diagnóstico</h1>
									<p class="text-white mb-0">Una forma efectiva de ver que capacidades falta desarrollar es respondiendo al Diagnóstico.</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Card item END -->
        </div>
      </div>
    </div>
  </section>
  <!-- ======================= Main banner END -->


    <!--INICIO SECCION 1-->
    <div class="container seccion-1">
    <div class="row">
      <div class="col-md-6 contenido">
        <h2 class="mb-4 titulo-pagina">¿Quiénes participan de Vía Verde?</h2>

        <!--<div class="subtitulo-pagina mb-4">Exportar con Sostenibilidad</div>-->

        <p>
          La Plataforma "Vía Verde - Exportar con Sostenibilidad" esta diseñado para apoyar en el fortalecimiento de capacidades a las Micro, Pequeñas y Medianas Empresas (MiPyme) de Bolivia que forman parte del sector agroforestal, para promover su internacionalización al mercado de la Unión Europea. 
          <br><br><span class="texto-resaltado-verde">Si usted es productor, emprendedor o tiene una empresa productora, transformadora o comercializadora de estos sectores, ¡Esta Plataforma es para usted!</span>  
        </p>

        <div class="control">
                    <div class="text-left">
                      <a
                        href="https://wa.me/59162387496"
                        class="btn btn-primary btn-lg boton-generar"
                      >
                        CONTÁCTANOS
                    </a>
                    </div>
        </div>
      </div>

      <div class="col-md-6">
        <img
          src="assets/images/img-1.jpg"
          alt="Imagen de un agricultor usando una tablet"
          class="img-fluid img-tablet img-responsive"
        />
      </div>
    </div>
  </div>
  <!--FIN SECCION 1-->


  <!--INICIO SECCION 2-->
    <div class="container seccion-2 mt-6">
      <div class="row">
        <h2 class="col-md-12 titulo">
            ¿Qué es una MiPyme?
        </h2>
        <div class="mt-3 subtitulo-pagina">Según la clasificación de tamaños en Bolivia:</div>
      </div>  

    <div class="row mt-4" >
      
      <div class="col-md-12 contenido">
        
        <div class="flexbox1">
            <div class="cuadro">
              <div class="icono"><img src="assets/images/quienes-participan/icon-1-persona.png" /></div>
              <div class="titulo1">
                Microempresa
              </div>
              <p>
                de 1 hasta 9 trabajadores
              </p>
            </div>
            <div class="cuadro">
              <div class="icono"><img src="assets/images/quienes-participan/icon-2-persona.png" /></div>
              <div class="titulo1">
                Pequeña empresa
              </div>
              <p>
                de 10 hasta 19 trabajadores
              </p>
            </div>
            <div class="cuadro">
              <div class="icono"><img src="assets/images/quienes-participan/icon-3-persona.png" /></div>
              <div class="titulo1">
                Mediana empresa
              </div>
              <p>
                de 20 hasta 49 trabajadores
              </p>
            </div>
        </div>
      </div>
      
      <div class="col-md-12 mt-4" >
        <div style="display: flex; justify-content: center;">
          <div style="max-width: 600px;">
            Las MiPymes representan la mayor parte del tejido empresarial del país y son las llamadas a <span style="color: #009644; font-weight: 600;">crecer con sostenibilidad y abrirse al mercado internacional.</span>
          </div>
        </div>
          
      </div>
      
    </div>

  </div>
  <!--FIN SECCION 2-->

    <!--INICIO SECCION 3-->
    <section class="container seccion-3 mt-6">
      <div class="row">
        <div class="col-md-12 titulo">
            Sectores: <br>Agrícola/Agroindustrial
            <br>Pecuario
            <br>Forestal/Maderero
        </div>
      </div>  

      <div class="parte2">
        <table style="width: 100%;">
          <tr>
            <td width="42%"><div style="background-image: url('assets/images/quienes-participan/linea.png'); background-repeat: repeat-x; width:auto; height: 10px;"></div></td>
            <td width="15%"><div style="text-align: center;"><img src="assets/images/quienes-participan/icon-1.png" width="70"/></div></td>
            <td width="43%"><div style="background-image: url('assets/images/quienes-participan/linea.png'); background-repeat: repeat-x; width:auto; height: 10px;"></div></td>
          </tr>
        </table>
      </div>

  <div class="elementos-container">
        
    <div class="elementos-left">
        <img src="assets/images/quienes-participan/fondo-sector-agricola.jpg" alt="Fondo sector agrícola">
        <div class="elementos-left-content">
            <h2>Sector Agrícola/Agroindustrial </h2>
            <p style="position: absolute;top: 100px;padding: 5px;text-align: justify;margin: 0px 30px 0px 0px;"><br>Empresas que producen materias primas, y procesan o transforman materias primas en alimentos como:</p>
            <a href="" class="btn btn-primary btn-lg boton-generar">Contáctanos</a>
        </div>
    </div>

    <div class="elementos-right">
        <div class="grid-categorias">

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-2.png" alt="dd"></div>
                <div>
                    <h3>Granos y semillas</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-6.png" alt=""></div>
                <div>
                    <h3>Legumbres</h3>                  
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-3.png" alt=""></div>
                <div>
                    <h3>Harinas y derivados</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-7.png" alt=""></div>
                <div>
                    <h3>Hierbas aromáticas y medicinales</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-4.png" alt=""></div>
                <div>
                    <h3>Café y cacao</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-8.png" alt=""></div>
                <div>
                    <h3>Productos agroindustriales</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-5.png"  alt=""></div>
                <div>
                    <h3>Frutas frescas y procesadas</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-9.png" alt=""></div>
                <div>
                    <h3>Otros</h3>
                </div>
            </div>

        </div>
    </div>
  
  </div>

  <div class="parte2">
        <table style="width: 100%;">
          <tr>
            <td width="42%"><div style="background-image: url('assets/images/quienes-participan/linea-2.png'); background-repeat: repeat-x; width:auto; height: 10px;"></div></td>
            <td width="15%"><div style="text-align: center;"><img src="assets/images/quienes-participan/icon-10.png" width="70"/></div></td>
            <td width="43%"><div style="background-image: url('assets/images/quienes-participan/linea-2.png'); background-repeat: repeat-x; width:auto; height: 10px;"></div></td>
          </tr>
        </table>
  </div>

  <div class="elementos-container">
        
    <div class="elementos-left">
        <img src="assets/images/quienes-participan/fondo-sector-pecuario.jpg" alt="Fondo sector agrícola">
        <div class="elementos-left-content">
            <h2>Sector Pecuario</h2>
            <p style="position: absolute;top: 100px;padding: 5px;text-align: justify;margin: 0px 30px 0px 0px;">Negocios vinculados a la ganadería y sus derivados:</p>
            <a href="" class="btn btn-primary btn-lg boton-generar">Contáctanos</a>
        </div>
    </div>

    <div class="elementos-right">
        <div class="grid-categorias">

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-2.png" alt="dd"></div>
                <div>
                    <h3>Carde de res, cerdo y aves</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-6.png" alt=""></div>
                <div>
                    <h3>Miel y productos apícolas</h3>                  
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-3.png" alt=""></div>
                <div>
                    <h3>Pieles y cueros</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-7.png" alt=""></div>
                <div>
                    <h3>Fertilizantes orgánicos</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-4.png" alt=""></div>
                <div>
                    <h3>Leche y derivados</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-8.png" alt=""></div>
                <div>
                    <h3>Lana e hilados de origen animal</h3>
                </div>
            </div>

        </div>
    </div>
  
  </div>


    <div class="parte2">
        <table style="width: 100%;">
          <tr>
            <td width="42%"><div style="background-image: url('assets/images/quienes-participan/linea-2.png'); background-repeat: repeat-x; width:auto; height: 10px;"></div></td>
            <td width="15%"><div style="text-align: center;"><img src="assets/images/quienes-participan/icon-11.png" width="70"/></div></td>
            <td width="43%"><div style="background-image: url('assets/images/quienes-participan/linea-2.png'); background-repeat: repeat-x; width:auto; height: 10px;"></div></td>
          </tr>
        </table>
  </div>

  <div class="elementos-container">
        
    <div class="elementos-left">
        <img src="assets/images/quienes-participan/fondo-sector-forestal.jpg" alt="Fondo sector agrícola">
        <div class="elementos-left-content">
            <h2>Sector Forestal/Maderero</h2>
            <p style="position: absolute;top: 100px;padding: 5px;text-align: justify;margin: 0px 30px 0px 0px;">Empresas relacionadas con la extracción, aprovechamiento, producción, transformación y uso sostenible de los recursos forestales maderables:</p>
            <a href="" class="btn btn-primary btn-lg boton-generar">Contáctanos</a>
        </div>
    </div>

    <div class="elementos-right">
        <div class="grid-categorias">

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-18.png" alt="dd"></div>
                <div>
                    <h3>Madera en bruto y aserrada</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-19.png" alt=""></div>
                <div>
                    <h3>Artesanías y utencillos de cocina</h3>                  
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-12.png" alt=""></div>
                <div>
                    <h3>Tableros y derivados</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-13.png" alt=""></div>
                <div>
                    <h3>Carbón vegetal y biomasa forestal</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-14.png" alt=""></div>
                <div>
                    <h3>Papel y cartón</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-15.png" alt=""></div>
                <div>
                    <h3>Productos de bambú y palma</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-16.png" alt=""></div>
                <div>
                    <h3>Muebles de madera</h3>
                </div>
            </div>

            <div class="item">
                <div class="icono"><img src="assets/images/quienes-participan/icon-17.png" alt=""></div>
                <div>
                    <h3>Otros</h3>
                </div>
            </div>
        </div>
    </div>
  
  </div>

</section>
  <!--FIN SECCION 3-->

  <section class="container seccion-4 mt-6">
      <div class="row">
        <div class="col-md-12 titulo">
            ¿Por que sumarse a  Vía Verde?
        </div>
        <div class="mt-3 subtitulo-pagina">Por que a través de está Plataforma usted puede:</div>
      </div> 

      <div class="contenedor-cards">

    <!-- CARD 1 -->
    <div class="card-sumarse">
        <img src="assets/images/quienes-participan/img-evaluar-sostenibilidad.jpg" alt="">
        <div class="card-contenido">
            <h3>Evaluar la sostenibilidad de su empresa</h3>
            <p>Con herramientas prácticas para autodiagnóstico de sostenibilidad y capacitaciones asincrónicas. Estas herramientas permiten a las MiPymes identificar brechas, recibir recomendaciones aplicables y adquirir conocimientos especializados para mejorar su gestión, fortalecer capacidades internas y avanzar hacia el cumplimiento de estandares del mercado europeo cada vez más exigentes.</p>
        </div>
        <div class="card-boton">➜</div>
    </div>

    <!-- CARD 2 -->
    <div class="card-sumarse">
        <img src="assets/images/quienes-participan/img-accede-capacitaciones.jpg" alt="">
        <div class="card-contenido">
            <h3>Accede a capacitaciones, talleres y guías prácticas</h3>
            <p>Diseñadas para enfrentar las principales barreras y normativas de acceso al mercado europeo, Como el Reglamento de la Unión Europea contra la Deforestación (EUDR). Más que requisitos, entender y saber cómo aplicar regulaciones que puede convertirse en una ventaja competitiva que diferencie a su empresa, permitiéndote ofrecer trazabilidad veriﬁcable,
fortalecer la conﬁanza de sus clientes y posicionarse en nichos o segmentos de mayor valor.</p>
        </div>
        <div class="card-boton">➜</div>
    </div>

    <!-- CARD 3 -->
    <div class="card-sumarse">
        <img src="assets/images/quienes-participan/img-conectarse-oportunidades.jpg" alt="">
        <div class="card-contenido">
            <h3>Conectarse con oportunidades reales de exportación</h3>
            <p>Hacia la Unión Europea. Las empresas
que integren la sostenibilidad y la trazabilidad
como
parte de su
propuesta de

valor
podrán
proteger sus
márgenes,

diversiﬁcar
mercados
y
acceder
a
clientes
que
pagan
más
por
la
conﬁabilidad

y el
cumplimiento de
estándares.</p>
        </div>
        <div class="card-boton">➜</div>
    </div>

</div>

  </section>

  <section class="resumen-section" style="">
    <div class="resumen-overlay" style="background: url('assets/images/quienes-participan/img-fondo-resumen.jpg') no-repeat center center/cover;">
        <h2>En resumen</h2>
        <p>
            Si usted tiene una MiPyme boliviana en el sector Agrícola/Agroindustrial, Pecuario o Forestal/Maderero, puede acceder a Vía Verde. 
            Esta es su oportunidad para producir de manera responsable, fortalecer su sostenibilidad y abrir las puertas de su 
            empresa hacia los mercados europeos, llevando con orgullo lo mejor de Bolivia a la Unión Europea.
        </p>
        <a href="https://wa.me/59162387496" class="btn-resumen">Contáctanos</a>
    </div>
</section>


</template>

<script>
export default {

}
</script>

<style scoped>
  .seccion-1 .contenido .titulo-pagina {
  font-family: "Merriweather";
  font-size: 40px;
  font-weight: 900;
  line-height: 140%;
  color: #00a052;
  
  }

.seccion-1 .contenido p{
  text-align: justify;
  font-family: "Montserrat";
}
/* SECCION 2  */
.seccion-2 {
  font-family: "Montserrat";
  }
.seccion-2 .titulo {
  font-family: "Merriweather";
  font-size: 40px;
  font-weight: 900;
  line-height: 140%;
  color: #00a052;
  text-align: center;
  }

  .seccion-2 .subtitulo-pagina,.seccion-4 .subtitulo-pagina {
  font-family: "Montserrat";
  font-size: 20px;
  text-align: center;
  }
  .seccion-2 .contenido .flexbox1 {
    display: flex;
    justify-content: space-evenly;
  }
  .seccion-2 .contenido .flexbox1 .cuadro {
    width: auto;
    padding: 10px 15px;
    
    border: #00a052 2px solid;
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
  .seccion-2 .contenido .flexbox1 .cuadro .titulo1{
    font-size: 16px;
    font-family: "Montserrat";
    color: #00a052;
    font-weight: 700;
    text-align: center;
  }
  .seccion-2 .contenido .flexbox1 .cuadro p{
    font-size: 14px;
  }
  .seccion-2 .contenido .flexbox1 .cuadro .icono{
    text-align: center;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .seccion-2 .contenido .flexbox1 .cuadro .icono img{
    height: 60px;
  }
/* SECCION 3 */
  .seccion-3 {
  font-family: "Montserrat";
  }
  .seccion-3 .titulo,.seccion-4 .titulo {
  font-family: "Merriweather";
  font-size: 40px;
  font-weight: 900;
  line-height: 140%;
  color: #00a052;
  text-align: center;
  }
  .seccion-3 .parte2 {
    margin-top: 50px;  
  }



.elementos-container{
    display:flex;
    gap:40px;
    padding:40px;
    flex-wrap:wrap;
}

.elementos-left{
    position:relative;
    flex:1 1 350px;
    color:#fff;
    border-radius:20px;
    overflow:hidden;
    min-height:380px;
}

.elementos-left img{
    width:100%;
    height:100%;
    object-fit:cover;
    /*filter:brightness(0.4);*/
}

.elementos-left-content{
    position:absolute;
    inset:0;
    padding:40px;
    display:flex;
    flex-direction:column;
    justify-content:space-between;
}
.elementos-left-content p{
 font-size: 18px;
}
.elementos-left-content h2{
  font-family: "Merriweather";
  color: #fff;
}

.elementos-left-content a{
  color: #FFF;
  background-color: #00552F;
  border: #008d49 solid 1px;
}

.elementos-left button{
    background:#008f4a;
    color:#fff;
    padding:12px 24px;
    border:none;
    border-radius:40px;
    cursor:pointer;
    font-weight:bold;
}

.elementos-right{
    flex:1 1 350px;
    display:flex;
    align-items:center;
}

.grid-categorias{
    display:grid;
    grid-template-columns:repeat(auto-fit, minmax(260px, 1fr));
    gap:30px;
    width:100%;
}

.item{
    display:flex;
    align-items:center;
    gap:20px;
}

.item .icono{
    width:70px;
    min-width: 70px;
    height:70px;
    background:#00A652;
    border-radius:50%;
    display:flex;
    align-items:center;
    justify-content:center;
}

.item .icono img{
    height:40px;
    filter:brightness(0) invert(1);
}

.item h3{
    font-size:20px;
    color:#008d49;
}

@media(max-width:850px){
    .elementos-container{
        flex-direction:column;
    }
}




/* */


.contenedor-cards{
    display: flex;
    gap: 25px;
    padding: 40px;
    flex-wrap: wrap;
    justify-content: center;
}

/* ------------- TARJETA ------------- */
.card-sumarse{
    font-family: "Montserrat";
    background: #0c9f4a;
    width: 340px;
    border-radius: 22px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 18px rgba(0,0,0,0.12);
}
.card-sumarse h3{
  font-family: "Montserrat";
}
.card-sumarse img{
    width: 100%;
    height: 230px;
    object-fit: cover;
}

.card-contenido{
    padding: 25px;
}

.card-sumarse h3{
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    line-height: 22px;
    margin-bottom: 15px;
}

.card-sumarse p{
    color: #e7e7e7;
    font-size: 14px;
    line-height: 21px;
    text-align: justify;
}

/* ------------- BOTÓN CIRCULAR ------------- */
.card-boton{
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #fff;
    margin: 18px auto 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    cursor: pointer;
    transition: 0.2s;
}

.card-boton:hover{
    transform: scale(1.08);
}

/* ------------- RESPONSIVE ------------- */
@media(max-width:960px){
    .contenedor-cards{
        padding: 20px;
    }
}

@media(max-width:600px){
    .card-sumarse{
        width: 100%;
        max-width: 380px;
    }
}


/* */


.resumen-section{
    width: 100%;
     /* Reemplace fondo.jpg */
    padding: 90px 20px;
    position: relative;
    font-family: "Montserrat";
}

.resumen-section h2{
  font-family: "Merriweather";
}

.resumen-overlay{
    background: rgba(0, 128, 60, 0.78);
    width: 100%;
    text-align: center;
    padding: 70px 25px;
    border-radius: 6px;
}

.resumen-section h2{
    font-size: 48px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 18px;
}

.resumen-section p{
    max-width: 780px;
    margin: auto;
    font-size: 16px;
    line-height: 24px;
    color: #e8e8e8;
}

.btn-resumen{
    display: inline-block;
    margin-top: 28px;
    background: #ffffff;
    color: #0c9f4a;
    font-weight: 700;
    font-size: 16px;
    padding: 12px 38px;
    border-radius: 30px;
    text-decoration: none;
    transition: 0.2s;
}

.btn-resumen:hover{
    transform: scale(1.06);
}
    
/* RESPONSIVE */
@media(max-width:768px){
    .resumen-section h2{
        font-size: 32px;
    }
    .resumen-section p{
        font-size: 15px;
    }
}

</style>